import { C, scrollTo, useIsMobile } from '../styles';

// Fixed bottom CTA bar shown only on mobile so the scroll-to-form action is
// always reachable no matter where the visitor is on the page.
export default function MobileStickyCTA() {
  const isMobile = useIsMobile();
  if (!isMobile) return null;

  return (
    <>
      {/* Spacer so the fixed bar never covers the footer / last content */}
      <div style={{ height: 74 }} aria-hidden="true" />
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 90,
        background: 'rgba(15,26,36,0.98)',
        backdropFilter: 'blur(14px)',
        borderTop: `1px solid ${C.bdr}`,
        padding: '12px 16px calc(12px + env(safe-area-inset-bottom, 0px))',
      }}>
        <button
          onClick={() => scrollTo('submit')}
          style={{
            width: '100%',
            fontFamily: "'Instrument Sans', sans-serif",
            fontSize: 15, fontWeight: 600, letterSpacing: '0.04em',
            padding: '15px 20px', borderRadius: 6,
            border: `1.5px solid ${C.orange}`,
            background: C.orange, color: '#fff',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}
        >Get Quotes — Free</button>
      </div>
    </>
  );
}
